/**
 * Landing Declaration Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: support@indigo.si
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ERoleName = 'Fisherman' | 'Maintenance' | 'TenantAdmin' | 'SuperAdmin';

export const ERoleName = {
    Fisherman: 'Fisherman' as ERoleName,
    Maintenance: 'Maintenance' as ERoleName,
    TenantAdmin: 'TenantAdmin' as ERoleName,
    SuperAdmin: 'SuperAdmin' as ERoleName
};

